import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/Seo";

// NOTE: items in [BRACKETS] are placeholders the owner must complete before launch.

const SECTIONS = [
  {
    h: "Who is responsible for your data",
    p: [
      "The AI Doctor is operated by Nicolas Moreau, trading as The AI Doctor, 64 Lotissement Les Bastides, 83340 Les Mayons (Var), France. Company registration (SIREN/SIRET): [TO ADD BEFORE LAUNCH]. VAT number: [NOT YET PROVIDED — ADD IF REGISTERED]. Contact for anything privacy-related: info@theaidoctor.website.",
      "This policy covers theaidoctor.website and the embedded Check-Up portal. It does not replace a signed client service agreement.",
    ],
  },
  {
    h: "What I collect",
    p: [
      "Check-Up requests: your name, business name, email address, and optionally phone number, website, country and industry — plus your answers about how your business operates (where time goes, what's repetitive, which tools you pay for).",
      "Bookings: your name, email, chosen date and time. Payments: processed by Stripe — I never see or store your card number.",
      "This website itself sets no advertising trackers and no analytics cookies, and collects no browsing data. See the Cookie Policy for details.",
    ],
  },
  {
    h: "Why — and on what legal basis",
    p: [
      "Responding to your request and communicating about it: pre-contractual steps and legitimate interest in answering people who contact me.",
      "Delivering the Check-Up you asked for (diagnosis, results, follow-up call): performance of a service you requested.",
      "Booking and payment administration (confirmations, reminders, receipts): performance of a contract.",
      "Optional marketing emails: only with your separate consent. Giving me your email for a Check-Up is NOT treated as consent to marketing — you would have to opt in explicitly. There is currently no marketing list.",
    ],
  },
  {
    h: "Who processes it",
    p: [
      "The Check-Up form runs inside an embedded application hosted by Lovable. Transactional emails are sent via Resend. Payments are processed by Stripe. Appointment scheduling uses Zoho Calendar (only if you click through to it). Website hosting is provided by Emergent. Fonts are served by Google Fonts.",
      "Each processor handles your information only to deliver its part of the service, under its own privacy terms.",
    ],
  },
  {
    h: "International transfers",
    p: [
      "Some processors listed above may process data outside the EU/EEA. Where that happens, transfers rely on the EU Standard Contractual Clauses or the EU–US Data Privacy Framework certification of the processor concerned.",
    ],
  },
  {
    h: "How long I keep it",
    p: [
      "Check-Up answers and contact details are kept for 24 months after our last interaction, unless you ask for deletion sooner. Booking and payment records are kept for 10 years, as required by French accounting law.",
    ],
  },
  {
    h: "Your rights",
    p: [
      "You can request access, correction, export, restriction or deletion of your data, and object to processing, at any time. No forms, no ticket systems — email info@theaidoctor.website and it's handled, usually within a week.",
      "You also have the right to lodge a complaint with your data-protection authority — in France, the CNIL (cnil.fr).",
    ],
  },
  {
    h: "Security",
    p: [
      "Your information lives in access-controlled systems and travels over encrypted connections. No method is perfect, but your business details are treated like a patient's file: confidential by default.",
    ],
  },
  {
    h: "Changes & contact",
    p: [
      "If this policy changes, the changes appear on this page. Questions, requests, deletions: info@theaidoctor.website.",
      "Effective date: July 2026. Policy version: 2026-07.",
    ],
  },
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <Seo
        title="Privacy Policy | The AI Doctor"
        description="What happens to your information when you request a free AI Business Check-Up: what I collect, why, who processes it, and how to exercise your rights."
      />
      <PageHero
        eyebrow="Privacy"
        title="Your business details are a patient file. Confidential by default."
        intro="Plain-English version of what happens to your information when you request a Check-Up. No legal fog."
      />
      <section className="shell pb-28 lg:pb-40 max-w-3xl">
        <div className="border-t border-white/10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.04} className="py-10 border-b border-white/10">
              <h2 className="display text-2xl text-[#f5f3ee]">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-4 text-[#a7a7a2] text-lg leading-relaxed">{para}</p>
              ))}
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
